// frontend/src/pages/Send.jsx
// IMPROVED VERSION WITH ERROR HANDLING
import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import SendMoney from './SendMoney';

// Initialize Stripe with error handling
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Check if key exists and warn in development
if (!stripePublishableKey) {
  console.error('⚠️ STRIPE ERROR: REACT_APP_STRIPE_PUBLISHABLE_KEY is not defined!');
  console.error('Please add it to your .env file and Vercel environment variables.');
}

// Only load Stripe if key is present
const stripePromise = stripePublishableKey 
  ? loadStripe(stripePublishableKey)
  : Promise.resolve(null);

function Send({ user }) {
  // Show error if Stripe key is missing
  if (!stripePublishableKey) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-indigo-900 flex items-center justify-center p-6">
        <div className="bg-red-500/20 border border-red-500 text-red-200 p-8 rounded-xl max-w-2xl">
          <h2 className="text-2xl font-bold mb-4">⚠️ Stripe Configuration Error</h2>
          <p className="mb-4">
            The Stripe publishable key is missing. This is required for payment processing.
          </p>
          <div className="bg-red-900/50 p-4 rounded-lg font-mono text-sm mb-4">
            <p className="font-semibold mb-2">To fix this:</p>
            <ol className="list-decimal list-inside space-y-2">
              <li>Add <code className="bg-red-800 px-2 py-1 rounded">REACT_APP_STRIPE_PUBLISHABLE_KEY</code> to your .env file</li>
              <li>Add the same variable to Vercel: Settings → Environment Variables</li>
              <li>Redeploy your application</li>
            </ol>
          </div>
          <p className="text-sm text-red-300">
            Note: The key should start with <code>pk_test_</code> (test mode) or <code>pk_live_</code> (production)
          </p>
        </div>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      <SendMoney user={user} />
    </Elements>
  );
}

export default Send;